import { useEffect, useState } from "react";
import { Phone } from "lucide-react";
import { Logo } from "./Logo";
import { OpenBadge } from "./OpenHours";
import { useLang, scrollToId } from "../../lib/lang";
import { INFO } from "../../lib/content";

const LINKS = [["menu", "menu"], ["services", "services"], ["why", "why"], ["faq", "faq"]];

export const LangSwitch = ({ light }) => {
  const { lang, setLang } = useLang();
  return (
    <div data-testid="nav-language-toggle" className={`flex rounded-full border p-0.5 text-xs font-medium ${light ? "border-white/40" : "border-[#721121]/25"}`}>
      {["sv", "en"].map((l) => (
        <button
          key={l}
          data-testid={`lang-${l}-button`}
          onClick={() => setLang(l)}
          className={`rounded-full px-3 py-1.5 uppercase tracking-wider transition-colors duration-300 ${lang === l ? "bg-[#721121] text-white" : light ? "text-white" : "text-[#721121]"}`}
        >
          {l}
        </button>
      ))}
    </div>
  );
};

export const Nav = ({ offset = 0 }) => {
  const { t } = useLang();
  const [solid, setSolid] = useState(false);
  useEffect(() => {
    const on = () => setSolid(window.scrollY > 60);
    on();
    window.addEventListener("scroll", on, { passive: true });
    return () => window.removeEventListener("scroll", on);
  }, []);
  const light = !solid;
  return (
    <header data-testid="site-nav" style={{ top: offset }} className={`fixed inset-x-0 top-0 z-50 transition-[background-color,box-shadow,padding] duration-500 ${solid ? "bg-[#F6E8DA]/90 backdrop-blur-xl shadow-[0_1px_0_rgba(114,17,33,0.12)] py-3" : "py-5"}`}>
      <div className="mx-auto flex max-w-[1400px] items-center justify-between px-5 lg:px-10">
        <button data-testid="nav-logo" onClick={() => window.__lenis ? window.__lenis.scrollTo(0) : window.scrollTo(0, 0)}>
          <Logo light={light} />
        </button>
        <nav className="hidden lg:flex items-center gap-9">
          {LINKS.map(([id, key]) => (
            <button key={id} data-testid={`nav-link-${id}`} onClick={() => scrollToId(id)} className={`link-underline text-sm tracking-wide ${light ? "text-white" : "text-[#1C1917]"}`}>
              {t.nav[key]}
            </button>
          ))}
        </nav>
        <div className="flex items-center gap-3">
          <span className="hidden sm:inline-flex"><OpenBadge light={light} /></span>
          <LangSwitch light={light} />
          <a data-testid="nav-call-button" href={INFO.phoneHref} className={`hidden xl:flex items-center gap-2 text-sm ${light ? "text-white" : "text-[#721121]"}`}>
            <Phone size={15} /> {INFO.phone}
          </a>
          <span className="hidden md:block">
            <a data-testid="nav-order-button" href={INFO.phoneHref} className="btn-wine">
              {t.nav.order}
            </a>
          </span>
        </div>
      </div>
    </header>
  );
};
